"use client"

import React, { useEffect, useState } from "react"
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, Input } from "@nextui-org/react"
import { CButton, CookEInput } from "../../components/CommonComponents"


export default function EditProfile({ open, handleClose, formData, onSubmit }) {
  const [form, setForm] = useState({
    username: "",
    personalName: "",
  })
  const [error, setError] = useState("")

  useEffect(() => {
    setForm({
      username: formData?.username || "",
      personalName: formData?.personalName || "",
    })
  }, [formData])

  const closeModal = () => {

    setForm({ username: "", personalName: "" })
    handleClose()
  }

  const handleSubmit = () => {
    setError("")

    if (!form.username || !form.personalName) {
      setError("Please fill all fields")
      return
    }

    if (form.username.length < 3 || form.username.length > 20) {
      setError("Username must be between 3 and 20 characters")
      return
    }

    if (form.username.toLowerCase() !== form.username) {
      setError("Username must be in lowercase")
      return
    }

    onSubmit(form)
    closeModal()
  }

  return (
    <Modal
      isOpen={open}
      onClose={closeModal}
      placement="center"

    >
      <ModalContent>

        <ModalHeader className="flex flex-col gap-1">Edit Profile</ModalHeader>
        <ModalBody>
          <CookEInput
            label="User Name"
            placeholder="Enter your username"
            value={form.username}
            onChange={(e) => setForm({ ...form, username: e.target.value })}
            className={"!border !border-gray-400"}
            variant="bordered"
          />
          <CookEInput
            label="Personal Name"
            placeholder="Enter your personal name"
            value={form.personalName}
            onChange={(e) => setForm({ ...form, personalName: e.target.value })}
            variant="bordered"
          />
          {error && (
            <p className="text-red-500 text-sm mt-2">{error}</p>
          )}
        </ModalBody>
        <ModalFooter>
          <CButton variant="red" onClick={closeModal}>
            Close
          </CButton>
          <CButton variant="skin" onClick={handleSubmit}>
            Save
          </CButton>
        </ModalFooter>


      </ModalContent>
    </Modal>
  )
}

